module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-card"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.viewUrl,
      "title": _vm.linkTitle,
      "target": _vm.linkTarget
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [(_vm.item.annType === 'JB') ? _c('span', {
    staticClass: "job-tag type2"
  }, [_vm._v("가치동행일자리")]) : (_vm.item.BIZ_SE === 'IN49001') ? _c('span', {
    staticClass: "job-tag type1"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : (_vm.item.BIZ_SE === 'IN49003') ? _c('span', {
    staticClass: "job-tag type2"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : (_vm.item.BIZ_SE === 'IN49006') ? _c('span', {
    staticClass: "job-tag type3"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : (_vm.item.BIZ_SE === 'IN49007') ? _c('span', {
    staticClass: "job-tag type4"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : (_vm.item.BIZ_SE === 'IN49008') ? _c('span', {
    staticClass: "job-tag type5"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : (_vm.item.BIZ_SE === 'IN49009') ? _c('span', {
    staticClass: "job-tag type1"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : (_vm.item.BIZ_SE === 'IN49004') ? _c('span', {
    staticClass: "job-tag type2"
  }, [_vm._v(_vm._s(_vm.item.BIZ_SE_NM))]) : _vm._e(), _vm._v(" "), (_vm.showMark) ? _c('span', {
    staticClass: "mark"
  }, [_c('img', {
    attrs: {
      "src": "img/common/ico-mark01.svg",
      "alt": "이수"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showFavoriteButton) ? _c('button', {
    staticClass: "like-button",
    class: {
      'is-active': _vm.favoriteStatus
    },
    attrs: {
      "aria-label": _vm.favoriteStatus ? '관심 선택됨' : '관심 등록',
      "title": _vm.favoriteStatus ? '관심 선택됨' : '관심 등록'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleFavoriteClick.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-favor"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._t("title", function() {
    return [_c('a', {
      staticClass: "title-line",
      attrs: {
        "href": "javascript:void(0);",
        "title": "{{ item.ANN_NM }} 상세보기"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.item.ANN_NM) + "\n        ")])]
  }), _vm._v(" "), _vm._t("details", function() {
    return [(_vm.item.annType === 'IN') ? _c('p', {
      staticClass: "job-details"
    }, [_vm._v("\n          활동비 시급 : "), _c('strong', [_vm._v(_vm._s(_vm.item.actamtHamt) + "원")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.item.workConditionLabel) + " "), _c('span', {
      staticClass: "bar"
    }), _vm._v(" 신입\n        ")]) : _c('p', {
      staticClass: "job-details"
    }, [_vm._v("\n          운영기관 : " + _vm._s(_vm.item.OPER_ORG_NM) + "\n          "), _c('br'), _vm._v("\n          사업구분 : " + _vm._s(_vm.item.BIZ_SE_NM) + "\n        ")])]
  }), _vm._v(" "), _vm._t("recruitment-info", function() {
    return [_c('div', {
      staticClass: "recruitment-info"
    }, [_c('span', [_vm._v("모집인원 : "), _c('strong', [_vm._v(_vm._s(_vm.item.rcptPpl) + "명")])]), _vm._v(" "), _c('span', [_vm._v("모집기간 : "), _c('strong', [_vm._v(_vm._s(_vm.item.APPDURNG_STED))])])])]
  })], 2), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "card-footer"
  }, [(_vm.item.ANN_RCRT_STAT.includes('17003')) ? _c('button', {
    staticClass: "status-button apply"
  }, [_vm._v("\n        신청 · 접수하기 "), _c('span', [_vm._v("(D" + _vm._s(_vm.item.DDAY) + ")")])]) : (_vm.item.ANN_RCRT_STAT.includes('17002')) ? _c('button', {
    staticClass: "status-button"
  }, [_vm._v("\n        모집 예정입니다 "), _c('span', [_vm._v("(D" + _vm._s(_vm.item.DDAY) + ")")])]) : (_vm.item.ANN_RCRT_STAT.includes('17004')) ? _c('button', {
    staticClass: "status-button"
  }, [_vm._v("\n        마감되었습니다\n      ")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62978a02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/components/JobCard.vue
// module id = 1426
// module chunks = 6